// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, HasPagingParameters, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

const url = "api/sainc/billOfMaterialImage";

export interface BomModel extends BaseModel {
    uri: string;
    productIdLookup: {};
    billOfMaterialImages: any[];
}

export interface GetBomApiParameter extends ApiParameter, HasPagingParameters {
    productNumber?: string;
}

export async function getBom(parameter: GetBomApiParameter): Promise<ServiceResult<BomModel>> {
    try {
        const result = await get<BomModel>(url, parameter);
        return {
            successful: true,
            result,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.errorJson?.message,
        };
    }
}
